import React, { Component } from 'react'
import Navbar from '../Components/NavBar'
import Home from '../Components/Home'
import Footer from '../Components/Footer'

export class HomePage extends Component {
  render() {
    return (
      <div>
        <Navbar/>
        <Home/>
        <Footer/>
      </div>
    )
  }
}

export default HomePage
